import { Tag } from "antd";

import { CONCLUSION_STATUS_INDEX } from ".";

export const monthComparisonColumns = [
    { 
        title: "Metric", 
        dataIndex: "metric", 
        key: "metric"
    },
    { 
        title: "Previous", 
        dataIndex: "previous", 
        key: "previous", 
        align: "right" 
    },
    {
        title: "Current",
        dataIndex: "current",
        key: "current",
        align: "right",
        render: (v) => <span style={{ fontWeight: 700 }}>{v}</span>,
    },
    { 
        title: "Change", 
        dataIndex: "change", 
        key: "change", 
        align: "right" 
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        align: "right",
        render: (status = -1) => {

            const { color, label } = CONCLUSION_STATUS_INDEX[status] || {}

            return <Tag color={color} variant={'outlined'}>{label}</Tag>
        }
    },
];



export const rootCauseColumns = [
    { 
        title: "Rank", 
        dataIndex: "rank", 
        key: "rank", 
        width: 60 
    },
    { 
        title: "Root Cause", 
        dataIndex: "cause", 
        key: "cause" 
    },
    { 
        title: "Driver Affected", 
        dataIndex: "affected", 
        key: "affected" 
    },
    {
        title: "Impact",
        dataIndex: "impact",
        key: "impact",
        align: "right",
        // render: (impact) => (
        //     <StatusText
        //         text={impact}
        //         color={impact === "High" ? COLORS.red : COLORS.amber}
        //     />
        // ),
    },
  ];

export const driversActionColumns = [
    {
        title: "Driver",
        dataIndex: "name",
        key: "name",
        // render: (name, row) => (
        //     <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        //         <Initials name={name} />
        //         <div>
        //             <div style={{ fontWeight: 700 }}>{name}</div>
        //             <div style={{ color: COLORS.textMuted, fontSize: 12 }}>{row.id}</div>
        //         </div>
        //     </div>
        // ),
    },
    { 
        title: "Score", 
        dataIndex: "score", 
        key: "score" 
    },
    {
        title: "Grade",
        dataIndex: "grade",
        key: "grade",
        // render: (g) => <GradeBadge grade={g} />,
    },
    { 
        title: "Score Breakdown", 
        dataIndex: "breakdown", 
        key: "breakdown" 
    },
    { 
        title: "Main Issue", 
        dataIndex: "mainIssue", 
        key: "mainIssue" 
    },
    { 
        title: "Recommended Action", 
        dataIndex: "action", 
        key: "action" 
    },
];

export const safetyBreakdownColumns = [
    { 
        title: "Event", 
        dataIndex: "label", 
        key: "label" 
    },
    { 
        title: "Cases", 
        dataIndex: "cases",
        key: "cases", 
        align: "right" 
    },
    {
        title: "Change",
        dataIndex: "change",
        key: "change",
        align: "right",
        // render: (change, row) => (
        //     <StatusText text={change} color={row.up ? COLORS.red : COLORS.green} />
        // ),
    },
  ];

export const complianceBreakdownColumns = [
    { 
        title: "Issue", 
        dataIndex: "label", 
        key: "label" 
    },
    { 
        title: "Cases", 
        dataIndex: "cases", 
        key: "cases", 
        align: "right" 
    },
    {
        title: "Change",
        dataIndex: "change",
        key: "change",
        align: "right",
        // render: (change, row) => (
        //     <StatusText text={change} color={row.up ? COLORS.red : COLORS.green} />
        // ),
    },
  ];

export const fuelBreakdownColumns = [
    { 
        title: "Metric", 
        dataIndex: "label", 
        key: "label" 
    },
    { 
        title: "Current", 
        dataIndex: "value", 
        key: "value", 
        align: "right" 
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        align: "right",
        //   render: (status, row) => <StatusText text={status} color={row.color} />,
    },
  ];


